import { PARAGRAPH_STYLES as e } from "../../constants/default-styles.mjs";
//#region src/extensions/paragraph-extension/utils.ts
var t = (t = !1) => ({
	...e,
	...t ? {
		marginTop: "1rem",
		marginBottom: "1rem"
	} : {
		marginTop: "0",
		marginBottom: "0"
	}
});
//#endregion
export { t as getParagraphStyles };
